module.exports = __webpack_public_path__ + "static/media/apple.7282d9cd.png";